export default {
  // 共通
  common: {
    loading: '読み込み中...',
    status: 'ステータス',
    save: '保存',
    cancel: 'キャンセル',
    delete: '削除',
    edit: '編集',
    close: '閉じる',
    confirm: '確認',
    search: '検索',
    refresh: '更新',
    create: '作成',
    start: '開始',
    stop: '停止',
    yes: 'はい',
    no: 'いいえ',
    ok: 'OK',
    error: 'エラー',
    success: '成功',
    warning: '警告',
    info: '情報',
    copy: 'コピー',
    viewDetails: '詳細を表示',
    none: 'なし',
    copyFailed: 'コピーに失敗しました。手動でコピーしてください',
    sshCommandCopied: 'SSHコマンドがクリップボードにコピーされました',
    unknown: '不明'
  },

  // ナビゲーションとメニュー
  navigation: {
    topology: 'トポロジビュー',
    list: 'リストビュー',
    audit: '監査ログ',
    gcpManager: 'GCPマネージャー',
    projectId: 'プロジェクトID',
    loadResources: 'リソースを読み込み',
    loadPrompt: '下のボタンをクリックしてプロジェクトリソースを読み込み'
  },

  // 統計情報
  stats: {
    virtualMachines: '仮想マシン',
    disks: 'ディスク',
    createVM: 'VM作成',
    createDisk: 'ディスク作成'
  },

  // ユーザー情報
  user: {
    role: '役割',
    viewer: '閲覧者',
    editor: '編集者',
    admin: '管理者'
  },

  // フィルター
  filters: {
    searchPlaceholder: 'VMまたはディスクを検索...',
    showRunningOnly: '実行中のVMのみ表示'
  },

  // VM関連
  vm: {
    name: 'VM名',
    zone: 'ゾーン',
    machineType: 'マシンタイプ',
    cpu: 'CPU',
    memory: 'メモリ',
    gpu: 'GPU',
    systemDisk: 'システムディスク',
    running: '実行中',
    stopped: '停止中',
    starting: '開始中',
    stopping: '停止中',
    terminated: '終了',
    provisioning: 'プロビジョニング中',
    staging: 'ステージング中',
    repair: '修復中',
    unknown: '不明',
    startVM: 'VM開始',
    stopVM: 'VM停止',
    deleteVM: 'VM削除',
    editLabels: 'ラベル編集',
    // VM resize related
    resizeVM: {
      title: 'VMのサイズを変更',
      currentSpecs: '現在の仕様',
      autoSelectedType: '自動選択されたマシンタイプ',
      resize: 'サイズ変更',
      resizing: 'サイズ変更中...',
      cancel: 'キャンセル',
      error: {
        resizeFailed: 'サイズ変更に失敗しました'
      }
    },
    noVMs: 'VMが見つかりません',
    internalIP: '内部IP',
    externalIP: '外部IP',
    sshCommand: 'SSHコマンド',
    hasExternalIP: '外部IPがあります。直接接続可能',
    noExternalIP: '外部IPがありません。IAPトンネルを使用',
    ssmSessionManager: 'AWS SSM Session Managerで接続',
    sshCommandCopied: 'SSHコマンドがクリップボードにコピーされました',
    details: 'VM詳細',
    attachedDisks: '接続ディスク',
    na: 'N/A',
    gcloudComputeSsh: 'gcloud compute ssh',
    status: {
      running: '実行中',
      stopped: '停止中',
      terminated: '終了',
      suspended: '一時停止',
      suspending: '一時停止中',
      stopping: '停止中',
      unknown: '不明'
    },
    onPremise: 'オンプレミス'
  },

  // ディスク関連
  disk: {
    name: 'ディスク名',
    size: 'サイズ',
    status: 'ステータス',
    zone: 'ゾーン',
    type: 'タイプ',
    attached: '接続済み',
    detached: '切断済み',
    attachedDisk: '接続ディスク',
    detachDisk: 'ディスク切断',
    deleteDisk: 'ディスク削除',
    editLabels: 'ラベル編集',
    noDisks: 'ディスクが見つかりません',
    attachedVM: '接続VM',
    details: 'ディスク詳細',
    ready: '準備完了',
    creating: '作成中',
    restoring: '復元中',
    unknown: '不明',
    na: 'N/A',
    systemDisk: 'システムディスク',
    status: {
      ready: '準備完了',
      creating: '作成中',
      restoring: '復元中',
      shuttingDown: '閉じ中',
      unknown: '不明',
      pending: '待機中',
      available: '利用可能',
      attached: '接続済み'
    },
    error: {
      missingZone: 'ディスクを接続できません：ゾーン情報が不足しています。'
    },
    attachedTo: '接続先',
    device: 'デバイス',
    notAttached: '未接続',
    na: 'なし'
  },

  // ラベル関連
  labels: {
    title: 'ラベル',
    owner: '所有者',
    team: 'チーム',
    org: '組織',
    editLabels: 'ラベル編集',
    saveLabels: 'ラベル保存',
    labelsUpdated: 'ラベルが更新されました',
    ownerPlaceholder: '所有者を入力',
    teamPlaceholder: 'チームを入力',
    orgPlaceholder: '組織を入力',
    noLabels: 'ラベルなし',
    manageLabels: 'ラベル管理',
    currentLabels: '現在のラベル',
    invalidEmail: '有効なメールアドレスを入力してください'
  },

  // VM作成モーダル
  createVM: {
    title: '仮想マシン作成',
    name: '名前',
    machineType: 'マシンタイプ',
    zone: 'ゾーン',
    bootDisk: 'ブートディスク',
    bootDiskSize: 'ブートディスクサイズ (GB)',
    network: 'ネットワーク',
    subnetwork: 'サブネットワーク',
    externalIP: '外部IP',
    allowHTTP: 'HTTPトラフィックを許可',
    allowHTTPS: 'HTTPSトラフィックを許可',
    create: '作成',
    cancel: 'キャンセル',
    nameRequired: '名前を入力してください',
    machineTypeRequired: 'マシンタイプを選択してください',
    zoneRequired: 'ゾーンを選択してください',
    bootDiskSizeRequired: 'ブートディスクサイズを入力してください',
    creating: '作成中...',
    created: '仮想マシンが正常に作成されました',
    error: '仮想マシンの作成に失敗しました',
    gpuType: 'GPUタイプ',
    gpuCount: 'GPU数量',
    image: 'イメージ',
    serviceAccount: 'サービスアカウント',
    estimatedMonthlyCost: '推定月額費用',
    createFailed: 'VM作成に失敗しました',
    monthlyCostEstimate: '月額費用推定',
    computeResource: 'コンピュートリソース',
    gpuResource: 'GPU ({0}, {1}個)',
    storageResource: 'ストレージ ({size}GB)',
    total: '合計',
    month: '月',
    selectImage: 'イメージを選択',
    defaultServiceAccount: 'デフォルト（Compute Engine デフォルトサービスアカウント）',
    a100AutoMatch: 'A100 GPU 40G は A2 高GPUマシンに自動マッチします',
    gpuTypes: {
      none: 'GPUなし'
    },
    machineTypeGroups: {
      e2Series: 'E2 シリーズ (コスト効率型)',
      e2Standard: 'E2 スタンダード',
      e2HighCpu: 'E2 高CPU',
      n1Standard: 'N1 スタンダード',
      g2StandardL4: 'G2 スタンダード (L4 GPU)',
      n1StandardT4: 'N1 スタンダード (T4 GPU)'
    }
  },

  // ディスク作成モーダル
  createDisk: {
    title: 'ディスク作成',
    name: '名前',
    size: 'サイズ (GB)',
    type: 'タイプ',
    zone: 'ゾーン',
    region: 'リージョン',
    create: '作成',
    cancel: 'キャンセル',
    nameRequired: '名前を入力してください',
    sizeRequired: 'サイズを入力してください',
    typeRequired: 'タイプを選択してください',
    zoneRequired: 'ゾーンを選択してください',
    creating: '作成中...',
    created: 'ディスクが正常に作成されました',
    error: 'ディスクの作成に失敗しました',
    estimatedMonthlyCost: '推定月額費用',
    createFailed: 'ディスクの作成に失敗しました',
    types: {
      standard: '標準永続ディスク',
      ssd: 'SSD永続ディスク',
      balanced: 'バランス型永続ディスク'
    }
  },

  // 監査ログ
  audit: {
    title: '監査ログ',
    project: 'プロジェクト',
    action: 'アクション',
    resource: 'リソース',
    user: 'ユーザー',
    timestamp: 'タイムスタンプ',
    details: '詳細',
    filter: 'フィルター',
    clear: 'クリア',
    noLogs: 'ログが見つかりません',
    selectProject: 'プロジェクトを選択',
    searchPlaceholder: 'ユーザー、リソース名で検索...',
    allActions: 'すべてのアクション',
    allStatus: 'すべてのステータス',
    success: '成功',
    failed: '失敗',
    pending: '進行中',
    allResourceTypes: 'すべてのリソースタイプ',
    allProjects: 'すべてのプロジェクト',
    timeRange: '時間範囲',
    export: 'エクスポート',
    last7Days: '過去7日間',
    last30Days: '過去30日間',
    last90Days: '過去90日間',
    custom: 'カスタム',
    to: 'から',
    totalRecords: '総レコード数',
    successfulOperations: '成功した操作',
    failedOperations: '失敗した操作',
    activeUsers: 'アクティブユーザー',
    time: '時間',
    operator: '操作者',
    actionType: 'アクションタイプ',
    resourceName: 'リソース名',
    resourceType: 'リソースタイプ',
    projectId: 'プロジェクトID',
    status: 'ステータス',
    duration: '所要時間',
    noMatchingLogs: '一致する監査ログが見つかりません',
    clearFilters: 'フィルターをクリア',
    pageInfo: '{current}ページ / {total}ページ ({records}レコード)',
    logDetails: '監査ログ詳細',
    basicInfo: '基本情報',
    operationTime: '操作時間',
    zone: 'ゾーン',
    ipAddress: 'IPアドレス',
    detailedInfo: '詳細情報',
    errorInfo: 'エラー情報',
    fetchLogsFailed: '監査ログの取得に失敗しました',
    fetchStatsFailed: '統計情報の取得に失敗しました',
    actions: {
      vmCreate: 'VM作成',
      vmStart: 'VM開始',
      vmStop: 'VM停止',
      vmDelete: 'VM削除',
      diskCreate: 'ディスク作成',
      diskDelete: 'ディスク削除',
      diskAttach: 'ディスク接続',
      diskDetach: 'ディスク切断'
    },
    statuses: {
      success: '成功',
      failed: '失敗',
      pending: '進行中'
    }
  },

  // 通知
  notifications: {
    operationSuccess: '操作が成功しました',
    operationFailed: '操作が失敗しました',
    confirmDelete: '削除を確認しますか？',
    deleteSuccess: '削除が成功しました',
    deleteFailed: '削除が失敗しました',
    attachSuccess: '接続が成功しました',
    attachFailed: '接続が失敗しました',
    detachSuccess: '切断が成功しました',
    detachFailed: '切断が失敗しました'
  },

  // サブリージョン
  subregion: {
    title: 'サブリージョン',
    unknown: '不明なサブリージョン'
  },

  // 言語切り替え
  language: {
    zh: '中文',
    en: 'English',
    ja: '日本語',
    switchLanguage: '言語を切り替え'
  },

  // サイト切り替え
  siteSwitcher: {
    title: 'サイト切り替え',
    currentSite: '現在のサイト',
    switchSite: 'サイト切り替え',
    awsSite: 'AWSマネージャー',
    gcpSite: 'GCPマネージャー',
    awsUrl: 'ec2-manager.robotruck.internal.jp',
    gcpUrl: 'gce-manager.robotruck.internal.jp',
    switching: '切り替え中...',
    switchConfirm: '{site} に切り替えてもよろしいですか？',
    switchSuccess: '{site} への切り替えが成功しました',
    switchFailed: 'サイトの切り替えに失敗しました'
  },

  // チーム
  team: {
    siDev: 'SI Dev',
    algoDev: 'Algo Dev',
    infraDev: 'Infra Dev',
    hi: 'HI'
  },

  // 組織
  org: {
    engineering: 'Engineering',
    product: 'Product'
  },

  // Composables
  composables: {
    // エラーメッセージ
    errors: {
      loadResourcesFailed: 'リソースの読み込みに失敗しました',
      loadProjectsFailed: 'プロジェクトリストの取得に失敗しました',
      operationFailed: '操作に失敗しました',
      deleteFailed: '削除に失敗しました',
      attachFailed: '接続に失敗しました',
      detachFailed: '切断に失敗しました',
      createFailed: '作成に失敗しました',
      loadProjectFirst: '先にプロジェクトリソースを読み込んでください',
      fetchUserFailed: 'ユーザーデータの取得に失敗しました'
    },
    // 確認メッセージ
    confirm: {
      startVM: 'この仮想マシンを開始してもよろしいですか？',
      stopVM: 'この仮想マシンを停止してもよろしいですか？',
      deleteVM: 'この仮想マシンを削除してもよろしいですか？この操作は元に戻せません！',
      deleteDisk: 'このディスクを削除してもよろしいですか？この操作は元に戻せません！',
      detachDisk: 'VM {vmName} からディスク {diskName} を切断してもよろしいですか？'
    },
    // ステータス
    status: {
      running: '実行中',
      stopped: '停止中',
      terminated: '終了',
      unknown: '不明',
      ready: '準備完了',
      creating: '作成中',
      restoring: '復元中'
    },
    // ログメッセージ
    logs: {
      connectedToServer: 'サーバーに接続しました',
      disconnectedFromServer: 'サーバーから切断されました',
      websocketError: 'WebSocketエラー',
      vmOperationFailed: 'VM操作に失敗しました',
      deleteDiskFailed: 'ディスク削除に失敗しました',
      attachDiskFailed: 'ディスク接続に失敗しました',
      detachDiskFailed: 'ディスク切断に失敗しました',
      createDiskFailed: 'ディスク作成に失敗しました',
      cannotGetVMMonitoring: 'VM {vmName} の監視データを取得できません',
      cannotGetDiskMonitoring: 'ディスク {diskName} の監視データを取得できません',
      userNotAuthenticated: 'ユーザーがIAPで認証されていません',
      userAuthenticated: 'ユーザーが認証されました'
    },
    // 通知
    notifications: {
      autoRemove: '通知を自動削除'
    }
  }
};
